/**
 * LOS MENÚS DE JESÚS Y DE LOS ENTRENADORES, APARTE (Jesús, WhatsApp 28-09 22:14): «además de
 * los menús que están hechos por otros usuarios, utilizar unos menús que sean hechos por
 * entrenadores y ponerlos como aparte, que se puedan seleccionar también».
 *
 * En «Elige tu menú» es un chip más, «De entrenadores», al lado de «Recetas». Con él puesto se
 * piden al servidor solo los menús del equipo (`solo_entrenadores`); las recetas del
 * recetario tienen su propio chip. Quién es del equipo lo decide el servidor
 * (backend/core/menus_de_entrenadores.py) y lo dice en `de_entrenador`.
 */
export const CHIP_ENTRENADORES = 'entrenadores';

// Nombres de cuenta que no son de una persona («Admin», la cuenta del negocio): con ellos la
// tarjeta diría «Entrenador · Admin», así que se dice sin nombre.
const NOMBRE_GENERICO = /^(admin|administrador|equipo)\b/i;

// Lo que dice la etiqueta de procedencia de una tarjeta de menú.
export const etiquetaAutor = (menu) => {
    if (menu?.de_entrenador) {
        if (menu.autor_nombre && !NOMBRE_GENERICO.test(menu.autor_nombre.trim())) {
            return `Entrenador · ${menu.autor_nombre}`;
        }
        return menu.de_jesus ? 'De Jesús' : 'De un entrenador';
    }
    return menu?.autor_nombre ? `De ${menu.autor_nombre}` : 'De otros usuarios';
};

// Con el chip puesto, solo los del equipo (el servidor ya los filtra; esto es la red).
export const soloDeEntrenadores = (menus) => (menus || []).filter(m => m?.de_entrenador);
